import CityPageTemplate from "../city-template/CityPageTemplate";
import { eastpointeConfig } from "./data";

export default function EastpointePage() {
  return <CityPageTemplate config={eastpointeConfig} />;
}